import { DOMUtils } from '../../../../utils/dom'
import { AbstractWidgetAdapter, IWidgetAdapter } from '../adapter'

export class Slimcut extends AbstractWidgetAdapter implements IWidgetAdapter {
    public static DOM = {
        attrs: {
            publisherId: 'data-htmlid'
        }
    }

    public constructor(public el: Element, public adLight = false) {
        super(el, adLight)
    }

    /**
     * Load 3rd party javascript with widget data
     */
    public loadData(): void {
        const publisherId = this.el.getAttribute(Slimcut.DOM.attrs.publisherId)
        const scriptSource = 'https://static.freeskreen.com/ba/9/freeskreen.min.js'

        // only load the script if there is a partner ID to load
        if (publisherId) {
            DOMUtils.loadScript(scriptSource)
        }
    }

}
